import * as React from 'react';
import { Input, type InputProps } from '../Input';

export interface IntegerInputProps extends Omit<InputProps, 'value' | 'onChange' | 'type'> {
  value: string;
  onChange: (value: string) => void;
  maxDigits?: number;
}

/**
 * Поле целого неотрицательного числа: буквы и знаки в него просто не попадают.
 *
 * Не `type="number"`: браузерный числовой инпут тащит за собой стрелки, свою
 * локаль десятичного разделителя и умеет молча отдавать пустую строку при
 * невалидном вводе — отличить «стёр» от «набрал ерунду» по нему нельзя.
 * Здесь значение остаётся строкой, и вызывающий сам решает, что значит пусто.
 *
 * Раньше в сроки SLA можно было вписать буквы: разбор возвращал `null`, а null
 * в матрице означает «наследовать» — то есть набранное слово молча превращало
 * явный срок в унаследованный.
 *
 * @use целое неотрицательное число — вместо `type="number"` со стрелками и чужой локалью.
 */
export const IntegerInput = React.forwardRef<HTMLInputElement, IntegerInputProps>(
  function IntegerInput({ value, onChange, maxDigits = 6, ...rest }, ref) {
    return (
      <Input
        ref={ref}
        value={value}
        inputMode="numeric"
        autoComplete="off"
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, maxDigits))}
        {...rest}
      />
    );
  },
);
